import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@services/HttpClient.js';
import type { ApiResponse } from '@repo/types';
import type { NotificationsData } from '../types/index.js';

export function useNotificationsQuery() {
  return useQuery({
    queryKey: ['notifications', 'upcoming'],
    queryFn: async () => {
      const res = await httpClient.get<ApiResponse<NotificationsData>>('/api/v1/notifications');
      return res.data.data;
    },
    refetchInterval: 5 * 60 * 1000,
    staleTime: 2 * 60 * 1000,
  });
}
